import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import BaseAppService from '../platform/base-app-service';

var url = window.location.hostname;

if (url.includes("localhost")) {
  axios.defaults.baseURL = "https://localhost:7238";
} else {
  axios.defaults.baseURL = "https://api.portalmunicipio.docgedsistemas.com.br";
}

axios.defaults.paramsSerializer = {
  serialize: function (params: any) {
    return qs.stringify(params, { indices: false });
  }
}

const executeRequest = async (config: AxiosRequestConfig) => {
  let data = null;

  const applicationData = BaseAppService.getApplicationData();

  if (applicationData != undefined) {
    config.headers = {
      Authorization: `Bearer ${applicationData?.token}`,
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  } else {
    config.headers = {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    }
  }

  const result = await axios.request(config);
  data = result.data;

  return { data };
};



const HttpClient = {
  executeRequest
};

export default HttpClient;